import { render } from "./brandResults.vue?vue&type=template&id=a28e3786"
import script from "./brandResults.vue?vue&type=script&lang=js"
export * from "./brandResults.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__